import React from 'react';

export const OnlineLinkIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M11.3337 8.0013L5.33366 10.668L5.33366 5.33464L11.3337 8.0013Z" fill="#3659E3" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.666992 13.3346V2.66797H15.3337V13.3346H0.666992ZM2.00033 4.0013H14.0003V12.0013H2.00033V4.0013Z"
        fill="#3659E3"
      />
    </svg>
  );
};
